import isEmpty from 'lodash/isEmpty';
import { useEffect, useState } from 'react';

import { NewsAndEventsModel } from '../interface/news-and-events';

export const usePagination = (
  articleType: string,
  newsAndEventsContent: NewsAndEventsModel[]
) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [currentContent, setCurrentContent] = useState(newsAndEventsContent);

  useEffect(() => {
    const getNewsAndEventsData = async () => {
      const articleTypeQuery = isEmpty(articleType)
        ? ''
        : `&article_type=${articleType}`;

      const newsAndEventsData = await fetch(
        `/api/news?page=${currentPage}${articleTypeQuery}`
      );
      const attributes =
        (await newsAndEventsData.json()) as NewsAndEventsModel[];

      setCurrentContent(attributes);
    };
    getNewsAndEventsData();
  }, [currentPage]);

  function handlePageClick(page: number) {
    setCurrentPage(page);
  }

  return { currentContent, currentPage, handlePageClick };
};
